import type { AMLCaption, ParsedCaption } from '$types/Caption';

/**
 * Parses a timestamp string and returns the corresponding number of seconds.
 * @param timestamp - The timestamp string to parse, in the format HH:MM:SS or MM:SS or SS.
 * @returns The number of seconds represented by the timestamp.
 * @throws An error if the timestamp is in an invalid format.
 */
export function parseTimestamp(timestamp: string) {
	const matches = timestamp.match(/(?:([0-9]+):)?(?:([0-9]+):)?([0-9]+\.?[0-9]*)/);

	if (!matches) {
		throw new Error('Invalid timestamp format.');
	}

	let secs = parseFloat(matches[3] || '0');
	secs += parseFloat(matches[2] || '0') * 60; // mins
	secs += parseFloat(matches[1] || '0') * 60 * 60; // hours

	return secs;
}

/**
 * Parses an AMLCaption object and returns a ParsedCaption object.
 * @param caption - The AMLCaption object to parse.
 * @returns A ParsedCaption object with the parsed caption data.
 */
export function parseCaption(caption: AMLCaption): ParsedCaption {
	return {
		text: caption.text,
		start: parseTimestamp(caption.start),
		end: parseTimestamp(caption.end),
	};
}

export function parseTimestampSimple(timestamp: string) {
	const matches = timestamp.match(/([0-9]+):([0-9]+)/);

	if (!matches || !matches[1] || !matches[2]) {
		throw new Error('Invalid timestamp format.');
	}

	const mins = parseInt(matches[1], 10);
	const secs = parseInt(matches[2], 10);

	return mins * 60 + secs;
}

